/**
 * LibraryAgentRouter — smart dispatcher for /library/agents/:id.
 *
 * On mount, checks if a structured agent definition exists for the id at
 * scope=platform-agent-def. If yes, renders the StructuredAgentEditor.
 * Otherwise falls back to the legacy prose editor (LibraryAgentDetail).
 *
 * This keeps existing URLs working while migrating to the structured editor:
 *   /library/agents/appointment_reminder  → structured editor (DB has agent_appointment_reminder)
 *   /library/agents/some_legacy_template  → legacy prose editor (no structured def)
 */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as api from "../api.js";
import { Loading } from "../components.jsx";
import StructuredAgentEditor from "./StructuredAgentEditor.jsx";
import LibraryAgentDetail from "./LibraryAgentDetail.jsx";

export default function LibraryAgentRouter() {
  const { id } = useParams();
  const [hasStructured, setHasStructured] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await api.getPlatformAgentDef(id);
        if (!cancelled) setHasStructured(true);
      } catch {
        if (!cancelled) setHasStructured(false);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (hasStructured === null) return <Loading />;
  if (hasStructured) return <StructuredAgentEditor />;
  return <LibraryAgentDetail />;
}
